const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/admin/feature-pages/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { adminPageTitle } from "@/routes/_app/admin/admin-page-title";
type FeaturePageIndexItem = RouterOutputs["featurePages"]["adminGetIndex"]["items"][number];
export const Route = createFileRoute("/_app/admin/feature-pages/")({
  head: () => ({
    meta: [{
      title: adminPageTitle("Feature Pages")
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});